export default __webpack_public_path__ + "static/media/access-sended.30d1c953.svg";